module.exports = __webpack_public_path__ + "img/footer.e1e82f7a.png";